import * as types from '../actions/types';

const initialState = {
  isAuthenticated: false,
  isLoading: false,
  errorMessage: null,
  user: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_USER:
    case types.VERIFY_TOKEN_START:
      return {
        ...state,
        isLoading: true,
      };
    case types.LOGIN_USER_SUCCESS:
    case types.VERIFY_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        errorMessage: null,
        user: action.payload,
      };
    case types.LOGIN_USER_FAIL:
    case types.VERIFY_TOKEN_FAIL:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        isAuthenticated: false,
      };
    case types.LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        user: {},
      };
    default:
      return state;
  }
};

export const getSignedInUser = (state) => (state.user);
export const getRoleOfSignedInUser = (state) => (state.user.role);
export const checkIfUserIsAuthenticated = (state) => (state.isAuthenticated);
export const checkIfAppIsCurrentlyVerifyingUser = (state) => (state.isLoading);
